import { render, staticRenderFns } from "./MyQuotesTableHeader.vue?vue&type=template&id=684cf252&scoped=true"
import script from "./MyQuotesTableHeader.vue?vue&type=script&lang=ts"
export * from "./MyQuotesTableHeader.vue?vue&type=script&lang=ts"
import style0 from "./MyQuotesTableHeader.vue?vue&type=style&index=0&id=684cf252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684cf252",
  null
  
)

export default component.exports